import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class GrievanceTypeService {

  constructor(public httpClient: HttpClient) { }


  //submit rest
  async submitGrievanceType(data: any) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.createGrievanceType, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load grievance type rest
  async loadGrievanceType() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceTypeV2, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


  //load departments type rest
  async loadDepartments(boardId: any) {
    const data = { 'bdId': boardId, };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadDepartment, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load board rest
  async loadBoard() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadBoard, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //view signleGrievanceType
  async viewSignleGrievanceType(gtId) {
    const data={
      'gtId':gtId
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.getOneGrievanceType,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


   //view signleGrievanceType
   async updateGrievanceType(data) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.updateGrievanceType,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //
  async deleteGrievanceType(data){
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.deleteGrievanceType,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
}

